var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticClass:"custom-input1",attrs:{"contenteditable":"true"},on:{"click":_vm.onclick,"input":_vm.inputText,"blur":_vm.inputBlur,"focus":_vm.inputFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }